import { createFileRoute } from "@tanstack/react-router";
import { parseCustomersListSearch } from "@/features/customers/schemas";

// Detail route carries the list filters through untouched so the "back" button
// can restore the exact same customers-list search/tag/brand/page.
export const Route = createFileRoute("/_app/customers/$customerId")({
  validateSearch: parseCustomersListSearch,
});
